/*
 * @Author: 杨道博
 * @Date: 2022-08-01 11:06:40
 * @Description: 用户信息管理模块
 * @FilePath: \GNSS面雨量预测预报系统\src\store\modules\user.js
 */
const state = {
    yj_code: sessionStorage.getItem('yj_code')|| '65dce2fb-4122-4b73-9487-c2e91bad934c', //应急系统返回的授权码
    yj_token: sessionStorage.getItem('yj_token')|| 'feca8c25-2ea1-4538-8b81-4c1d03910159', 
    token: sessionStorage.getItem('token'), //自己系统toke    
    refresh_token: sessionStorage.getItem('refreshToken')||'', //刷新的token
    userInfo: JSON.parse(sessionStorage.getItem('userInfo'))||{}, //自己系统的用户信息
    xzqhTree: JSON.parse(sessionStorage.getItem('xzqhTree')) || [], //行政区划数据
    menuList: JSON.parse(sessionStorage.getItem('menuList')) || [], //系统菜单数据
    systemUrl: "https://59.208.208.132:3001", //环境部署跳转地址
    activeMenu: "",
    mapCenterInfo:{},
    JSDWOptions:[], // 建设单位
    SJDWOptions:[], // 设计单位
    SGDWOptions:[], // 施工单位
    JLDWOptions:[], // 监理单位
    LcOptions:[], // 流程
    fzrOptions:[], // 负责人
    sblxOptions:[], // 设备类型
    CJDWOptions:[], // 设备类型
}

const mutations = {
    setYjCode(state, yjCode) { //存储应急登录返回的授权码
        sessionStorage.setItem('yj_code', yjCode);
        state.yj_code = yjCode;
    },
    setYjToken(state, yjToken) { //存储应急登录返回的token
        sessionStorage.setItem('yj_token', yjToken);
        state.yj_token = yjToken;
    },
    setToken(state, token) {
        sessionStorage.setItem('token', token);
        state.token = token;
    },
    setRefreshToken(state, refreshToken) {
        sessionStorage.setItem('refreshToken', refreshToken);
        state.refresh_token = refreshToken;
    },
    setUserInfo(state, userInfo) {
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
        state.userInfo = userInfo;
    },
    setXzqhTree(state, treeData) {
        sessionStorage.setItem('xzqhTree', JSON.stringify(treeData))
        state.xzqhTree = treeData;
    },
    setMenuList(state, menuData) {
        sessionStorage.setItem('menuList', JSON.stringify(menuData))
        state.menuList = menuData;
    },
    setActiveMenu(state, menu){
        state.activeMenu = menu;
    },
    setMapCenter(state, info){
        state.mapCenterInfo = info;
    },
    setState(state,data){
        state[data.key] = data.value;
    }
}

const actions = {
    // 退出登录，清除数据
    logoutAct(context) {
        sessionStorage.clear();
        context.commit('setYjCode', '');
        context.commit('setYjToken', '');
        context.commit('setToken', '');
        context.commit('setRefreshToken', '');
        context.commit('setUserInfo', {});
        context.commit('xzqhTree', []);
        context.commit('setMenuList', []);
    },
}

export default{
    namespaced: true,
    state,
    mutations,
    actions
}